import { createFileRoute, redirect } from "@tanstack/react-router";

import { AuditPage } from "@/features/audit/AuditLog";

export const Route = createFileRoute("/_app/audit")({
  beforeLoad: ({ context }) => {
    // The laptop's audit log is on the admin page; this page is the cloud's.
    if (context.info.edition !== "cloud" || !context.me?.permissions.includes("audit.read")) {
      throw redirect({ to: "/worklist" });
    }
  },
  component: AuditPage,
});
